import agda from "refractor/agda";
export default agda;